module.exports = __webpack_public_path__ + "img/EXTERIOR-SCROSS-2.d707d5af.jpg";